// External imports
import React from 'react';
import { Typography } from '@material-ui/core';
import moment from 'moment-timezone';
// Styles
import '~/app/Components/TermsOfUse/css/termsOfUse.css';

/**
 * Footer Component showing Tax Year, Version Number and Copyright
 *
 * @component
 * @category Components
 * @subcategory Footer
 */
const TermsOfUse = () => {
  return (
    <div className="terms-of-use-container">
      <Typography variant="subtitle1" align="left">
        Copyright &copy; {moment().format('YYYY')} CrossLink. &nbsp;All rights reserved.&nbsp;&nbsp;
        <a
          href="https://www.crosslinktax.com/wp-content/uploads/2024/12/Website-Terms-of-Use-CrossLink-FOC-1-1-2025-1.pdf"
          rel="noreferrer"
          target="_blank"
        >
          Terms of Use
        </a>
      </Typography>
    </div>
  );
};

export default TermsOfUse;
